import { useCallback } from "react";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";

export default function useZadostiRowDetail({ id }) {
  const redirect = useRedirect();

  const redirectToDetail = useCallback(() => {
    redirect(PATHS.ZADOSTI.DETAIL, { id });
  }, [redirect, id]);

  return { handleClickDetail: redirectToDetail };
}
